/**
 * The rail's shared vocabularies — WS-Z6.
 *
 * Direction B rule 8 folded the seven control cards into one accordion, and an accordion head
 * has to SAY what its closed section is set to. That means two places now name the same value:
 * the `<option>` inside the card and the summary line on its head. Two hand-written copies of
 * "Max height" is exactly the kind of duplicate the owner's Rule A says to collapse, so the
 * option lists and the summaries read from these tables instead — one label per value, and a
 * new option cannot reach the dropdown without also reaching the head.
 *
 * `Record<T, string>` and not a lookup with a fallback: omitting a member is a tsc error, which
 * is what keeps the tables complete as the unions grow.
 */
import type { FitMode } from "@genz/engine-bind";
import type { ProductCategory } from "./compositing.js";

/** The product-profile select (`profile-category`) — drives the fill stack. */
export const PRODUCT_CATEGORY_LABEL: Record<ProductCategory, string> = {
  phone_case: "Phone case",
  color_case: "Color case",
  dark_case: "Dark case",
  uv_case: "UV case",
  mug: "Mug",
  generic: "Generic",
};

/** How the design fills the print area (`fill-mode`). */
export const FILL_FIT_LABEL: Record<FitMode, string> = {
  contain: "Contain",
  cover: "Cover",
  stretch: "Stretch",
  height: "Max height",
  width: "Max width",
};

/** The preview-only backdrop modes (`bg-mode-*`). */
export const BG_MODE_LABEL: Record<"transparent" | "color" | "image", string> = {
  transparent: "Transparent",
  color: "Color",
  image: "Image",
};
